const degToRad = (degrees: number) => degrees * (Math.PI / 180);
export const polarToCartesian = (angle: number, r: number) => {
  const rad = degToRad(angle);
  return {
    x: Math.cos(rad) * r,
    y: Math.sin(rad) * r,
  };
};
